<template>
  <div class>
    <section class="hero is-medium is-primary is-bold background-image">
      <div class="hero-body">
        <div class="container title-container">
          <h1 class="promo_msg">Echipa Kinetica</h1>
        </div>
      </div>
    </section>
    <section class="section">
      <div class="container">
        <div class="logo_back">
          <div
            style="background: #ffffffb0; 
                  font-size: 18px;"
          >
            <div class="semi_content">
              <p>Kinetica s-a deschis în toamna anului 2011, cu scopul de prevenire şi tratament al tuturor deficienţelor aparatului locomotor.</p>
              <p>Fondatorii acestui centru de recuperare suntem noi, fraţii Oroian, fraţi gemeni, pe nume Liviu şi Ovidiu. În anul 2020 am reuşit să ne mutăm într-un centru de recuperare mai generos, prin finalizarea unui proiect finanţat prin fonduri europene.</p>
              <p>Suntem o echipă formată dintr-un doctor şi şapte terapeuţi meniţi să contribuie la o recuperare cât mai sigură a sănătăţii dumneavoastră, asigurând recuperarea pe următoarele categorii: recuperare pediatrică, recuperare la domiciliu, recuperarea vârstnicilor şi recuperarea sportivilor. Toate acestea utilizand tehnici de kinetoterapie, masaj şi fizioterapie.</p>
              <p>Fiind foşti sportivi de performanţă, avem bucuria de a ne revedea pacienţii întorşi la activităţile fizice sau activităţile sportive, de a le reda bucuria şi frumuseţea a tot ce înseamna mişcare, indiferent dacă o fac cu scopul de performanţă sau de a prevenţie.</p>
              <p>Nu uitaţi! Suntem aici şi pentru tine ca să te ajutăm.</p>
              <p>Prin mişcare vei obţine schimbarea!</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section">
      <div class="container">
        <h1>Fondatori</h1>
        <div class="flex_container" style="justify-content: center;">
          <div class="columns">
            <div class="column">
              <div class="cat" style="height: 300px;flex: none;">
                <img src="../assets/founder_1.jpg" alt="Fondator Ovidiu" class="founder_img" />
                <div class="cat_title">
                  <a href="oldies" class="cat_link">
                    Ovidiu Oroian - Kinetoterapist
                    <br />
                    <br />
                  </a>
                </div>
              </div>
            </div>
            <div class="column">
              <div class="cat" style="height: 300px;flex: none;">
                <img src="../assets/founder_2.jpg" alt="Fondator Liviu" class="founder_img" />
                <div class="cat_title">
                  <a href="oldies" class="cat_link">
                    Liviu Oroian - Kinetoterapist
                    <br />
                    <br />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// @ is an alias to /src
// import Hero from "@/components/Hero.vue";

export default {
  name: "DespreNoi",
  components: {
    // Hero,
  },
};
</script>

<style>
.page_logo_back {
  background-image: url("../assets/logo_k.webp");
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  height: 100%;
  position: absolute;
  width: 100%;
}
.logo_over {
  align-items: center;
  background: #fffc;
  display: flex;
  font-size: 1.5rem;
  height: 100%;
  justify-content: center;
  position: relative;
  z-index: 1;
}
.hero.is-primary.is-bold {
  /* background-image: url('../assets/JOC_3796.jpg') !important; */
  background-size: cover;
  background-position: center;
  height: 600px;
  background-position-y: -40px;
  background-repeat: no-repeat;
}
.background-image {
  background-image: url("../assets/despre-noi/JOC_2816.jpg") !important;
}
.cat {
  background-position-x: center;
  background-repeat: no-repeat;
  background-size: cover;
  height: 30rem;
  flex: 1 1 auto;
  margin: 0 0.2rem;
  position: relative;
}
.cat_title {
  align-items: center;
  background-color: #ffffffc0;
  bottom: 0;
  display: flex;
  font-weight: bold;
  height: 4rem;
  justify-content: center;
  padding: 0.5rem;
  position: absolute;
  width: 100%;
  z-index: 1;
}
.founder_img {
  height: 300px;
  width: 300px;
}
.flex_container {
  display: flex;
}
.semi_content {
  margin: 0 auto;
  max-width: 50rem;
}
.promo_msg {
  background: #ffffffc0;
  border-radius: 0.5rem;
  font-size: 2rem;
  margin: 0.5rem 0;
  padding: 0.5rem;
}
.title-container {
  margin: 0 auto;
  max-width: 400px;
  position: relative;
  padding-top: 380px;
}
.hero.is-primary {
  background-color: white;
}
</style>